import { render, staticRenderFns } from "./FireImage.vue?vue&type=template&id=665bf2dc&scoped=true&"
import script from "./FireImage.vue?vue&type=script&lang=js&"
export * from "./FireImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665bf2dc",
  null
  
)

export default component.exports